import React from 'react';
import Grid from 'components/atoms/Grid';
import Field from 'components/molecules/Field';
import Form from 'components/molecules/Form';

function PersonalizationSection({ form }) {
  return (
    <div className="personalization-holder">
      <span className="label">Personalization</span>

      <Grid xs={1} lg={2} colGap={10}>
        <Form.Item
          label="Sub Heading"
          name="personalization_sub_heading"
          type="text"
          sm
          rules={[{ required: false, message: 'Enter title' }]}>
          <Field />
        </Form.Item>
        <Form.Item
          label="Heading"
          name="personalization_heading"
          type="text"
          sm
          rules={[{ required: false, message: 'Enter title' }]}>
          <Field />
        </Form.Item>
      </Grid>
      <Form.Item
        label="Personalization Description"
        name="personalization_description"
        type="textarea"
        rules={[{ required: false, message: 'Enter title' }]}>
        <Field />
      </Form.Item>
      <Form.Item
        label="Personalization Image"
        name="personalization_image"
        type="chooseFile"
        displayFile={
          form.getFieldValue('personalization_image')?.preview || form.getFieldValue('personalization_image') || null
        }
        small
        rules={[{ required: false, message: `Select description image` }]}>
        <Field />
      </Form.Item>
    </div>
  );
}

export default PersonalizationSection;
